import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(auth)/join/page.jsx");
